export const RULES_PDF_URL =
  'https://5ka-media.x5static.net/media/hosting/file/044978cf-7d68-4985-a92b-221bfe399021.pdf'

export const DATA_PROCESSING_PDF_URL =
  'https://files.perekrestok.ru/static/files/d3/76/e698a7510dd8cxd48478d9010463.pdf'
